const formatCurrency = (value: number): string =>
  value.toLocaleString('en-US', {
    minimumFractionDigits: 2,
  });

export default formatCurrency;
